import { useCallback } from 'react';

import { AnnouncementBar } from '@/components/AnnouncementBar';
import { ItineraryCheckoutHeader } from '@/components/ItineraryCheckoutHeader/ItineraryCheckoutHeader';
import { Navbar } from '@/components/Navbar';
import { OverviewCard } from '@/components/OverviewCard';
import { Paragraph } from '@/components/Paragraph';
import { Spacer } from '@/components/Spacer';
import { Tag } from '@/components/Tag';
import { useModal } from '@/context/modal';
import { useItinerary } from '@/handlers/useItinerary';
import { StyledFlexColumn, StyledFlexRow } from '@/layout/FlexLayout';
import { EnforcePageWidth } from '@/layout/PageLayout';
import { ItineraryTravelerModal } from '@/pages/TravelParty/modals/ItineraryTravelerModal';
import { StyledPersonRows } from '@/pages/TravelParty/styles';
import { TravelPartyMemberButton, AddTravelPartyMemberButton } from '@/pages/TravelParty/TravelPartyMemberButton';

import { StyledDesktopView, StyledMobileView } from '../Payment/styles';

import type { ItineraryTravelerType } from '@/types/travelers';

export function TravelPartyPage() {
  const openModal = useModal();

  const openBookerModal = useCallback(
    (type: ItineraryTravelerType) => {
      openModal((props) => <ItineraryTravelerModal travelerType={type} {...props} />);
    },
    [openModal],
  );

  const { data } = useItinerary();
  if (!data) return null;

  const { registeredTravelers } = data;
  const hasMainBooker = registeredTravelers?.some((traveler) => traveler.type === 'Main Booker');
  const unregisteredTravelers = data.amountOfTravelers - (registeredTravelers?.length || 0);
  const unregisteredTravelersArray = unregisteredTravelers > 0 ? [...Array(unregisteredTravelers)] : [];

  return (
    <>
      <AnnouncementBar />
      <Navbar variant="secondary" />
      <ItineraryCheckoutHeader />
      <EnforcePageWidth>
        <Spacer size="lg" />
        <StyledFlexRow gap={10}>
          <StyledFlexColumn flex="2">
            <Tag>Step 2 of 3</Tag>
            <h2>Travel company</h2>
            <Paragraph color="tertiary">
              Who will be joining you on this trip? Add your fellow travelers to your booking.
            </Paragraph>
            <Spacer size="md" />
            <StyledPersonRows>
              {registeredTravelers?.map((registeredTraveler) => (
                <TravelPartyMemberButton key={registeredTraveler.id} traveler={registeredTraveler} />
              ))}

              {unregisteredTravelersArray.map((_, index) => (
                <AddTravelPartyMemberButton
                  key={Math.random()}
                  number={(registeredTravelers?.length || 0) + index + 1}
                  type={!hasMainBooker && index === 0 ? 'Main Booker' : 'Fellow Traveler'}
                  onClick={() => openBookerModal(!hasMainBooker && index === 0 ? 'Main Booker' : 'Fellow Traveler')}
                />
              ))}
            </StyledPersonRows>
          </StyledFlexColumn>
          <StyledDesktopView>
            <OverviewCard secondary />
          </StyledDesktopView>
        </StyledFlexRow>
        <StyledMobileView>
          <Spacer size="2xl" />
          <OverviewCard secondary />
        </StyledMobileView>
        <Spacer size="2xl" />
      </EnforcePageWidth>
    </>
  );
}
